'use client';
import classNames from 'classnames/bind';
import React, { isValidElement } from 'react';
import ToastWrapper from './ToastWrapper.mjs';
import { TOAST_ANIMATIONS } from '../../constants/toast.mjs';
import usePortal from '../../hooks/usePortal.mjs';
import styles from './ToastNotice.module.scss.mjs';

const cx = classNames.bind(styles);
function ToastNotice(_ref) {
  let {
    rightButton,
    children,
    duration,
    onDestroy,
    bottomPaddingBase
  } = _ref;
  const Portal = usePortal();
  if (!children) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement(ToastWrapper, {
    destroy: onDestroy,
    duration: duration,
    animation: TOAST_ANIMATIONS.FADE,
    bottomPaddingBase: bottomPaddingBase
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('article', {
      center: !rightButton
    })
  }, /*#__PURE__*/isValidElement(children) ? ( /*#__PURE__*/React.createElement("p", {
    className: cx('text')
  }, children)) : ( /*#__PURE__*/React.createElement("p", {
    className: cx('text'),
    dangerouslySetInnerHTML: {
      __html: `${children}`
    }
  })), rightButton ? ( /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: rightButton.onClick,
    className: cx('button-right')
  }, rightButton.text)) : null)));
}
ToastNotice.displayName = 'ToastNotice';

export { ToastNotice as default };
